<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="visible"
      width="550px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetInfo"
    >
      <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <!-- 代金券名称 -->
          <el-form-item label="代金券名称" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入代金券名称"
              style="width: 400px"
              maxlength="20"
              :disabled="isView"
            ></el-input>
          </el-form-item>
          <!-- 有效时间 -->
          <el-form-item label="有效时间" prop="validTime">
            <el-date-picker
              v-model="form.validTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 400px"
              :disabled="isView"
            ></el-date-picker>
          </el-form-item>
          <!-- 单张面额 -->
          <el-form-item label="单张面额" prop="amount">
            <el-input
              v-model="form.amount"
              placeholder="请输入单张面额"
              style="width: 400px"
              :disabled="isView"
            ></el-input>
          </el-form-item>
          <!-- 使用门槛（无门槛，满金额使用） -->
          <el-form-item label="使用门槛" prop="useLimitType">
            <el-radio-group v-model="form.useLimitType" :disabled="isView">
              <el-radio label="0">无门槛</el-radio>
              <el-radio label="1">
                <span>满</span>
                <el-input
                  v-model="form.useLimitAmount"
                  placeholder="请输入"
                  style="width: 88px; margin: 0px 10px"
                  @focus="handleUseLimitAmountFocus"
                  :disabled="isView"
                ></el-input>
                <span>元可用</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 使用条件（一次用完，可分多次使用） -->
          <el-form-item label="使用条件" prop="useWay">
            <el-radio-group v-model="form.useWay" :disabled="isView">
              <el-radio label="0">一次用完</el-radio>
              <el-radio label="1">可分多次使用</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 总量 -->
          <el-form-item label="总量" prop="maxSendQty" :disabled="isView">
            <el-input
              v-model="form.maxSendQty"
              placeholder="请输入总量"
              style="width: 400px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" v-show="!isView">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSave" :loading="submitLoading"
          >存草稿</el-button
        >
        <el-button
          type="primary"
          @click="handlePublish"
          :loading="submitLoading"
          >发布</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addVoucherInfo,
  getVoucherInfoDetail,
  editVoucherInfo,
} from "@/api/voucher";
import dayjs from "dayjs";
export default {
  name: "voucherAddDlg",
  data() {
    return {
      visible: false,
      dialogTitle: "新建",
      isView: false,
      form: {
        name: "",
        validTime: "",
        amount: "",
        useLimitType: "0",
        useLimitAmount: "",
        useWay: "0",
        maxSendQty: "",
        id: "",
      },
      submitLoading: false,
      rules: {
        // 代金券名称长度 20
        name: [
          { required: true, message: "请输入代金券名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        // 有效时间必填
        validTime: [
          { required: true, message: "请选择有效时间", trigger: "blur" },
        ],
        // 单张金额 1-100000 正整数
        amount: [
          { required: true, message: "请输入单张面额", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "单张面额必须为正整数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 5,
            message: "单张面额必须在 1 到 100000 之间",
            trigger: "blur",
          },
        ],
        // 使用门槛
        useLimitType: [
          { required: true, message: "请选择使用门槛", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "1") {
                if (this.form.useLimitAmount === "") {
                  callback(new Error("请输入使用门槛金额"));
                } else {
                  // 金额必须为正整数, 1-100000
                  if (!/^[1-9]\d*$/.test(this.form.useLimitAmount)) {
                    callback(new Error("使用门槛金额必须为正整数"));
                  } else {
                    if (
                      parseInt(this.form.useLimitAmount) < 1 ||
                      parseInt(this.form.useLimitAmount) >= 100000
                    ) {
                      callback(
                        new Error("使用门槛金额必须在 1 到 100000 之间")
                      );
                    } else {
                      callback();
                    }
                  }
                }
              } else {
                this.form.useLimitAmount = "";
                callback();
              }
            },
            trigger: "change",
          },
        ],
        // 使用条件
        useWay: [
          { required: true, message: "请选择使用条件", trigger: "blur" },
        ],
        // 总量 1-100000 正整数
        maxSendQty: [
          { required: true, message: "请输入总量", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "总量必须为正整数",
            trigger: "blur",
          },
          {
            min: 1,
            max: 5,
            message: "总量必须在 1 到 100000 之间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submit(state) {
      this.submitLoading = true;
      let obj = { ...this.form };
      if (obj.validTime) {
        obj.startDate = dayjs(obj.validTime[0]).format("YYYY-MM-DD HH:mm:ss");
        obj.endDate = dayjs(obj.validTime[1]).format("YYYY-MM-DD HH:mm:ss");
      }
      obj["state"] = state;
      if (this.form.id) {
        editVoucherInfo(obj)
          .then((res) => {
            this.visible = false;
            this.$emit("refresh");
            this.$message.success("编辑成功");
          })
          .finally(() => {
            setTimeout(() => {
              this.submitLoading = false;
            }, 1000);
          });
      } else {
        addVoucherInfo(obj)
          .then((res) => {
            this.visible = false;
            this.$emit("refresh");
            this.$message.success("保存成功");
          })
          .finally(() => {
            setTimeout(() => {
              this.submitLoading = false;
            }, 1000);
          });
      }
    },
    publicOpen() {
      this.dialogTitle = "新增";
      this.visible = true;
    },
    publicViewOpen(id) {
      this.isView = true;
      this.dialogTitle = "详情";
      this.getVoucherDetailById(id);
    },
    publicEditOpen(id) {
      this.dialogTitle = "编辑";
      this.getVoucherDetailById(id);
    },
    getVoucherDetailById(id) {
      getVoucherInfoDetail(id).then((res) => {
        this.form = {
          name: res.name,
          validTime: [
            dayjs(res.startDate).format("YYYY-MM-DD HH:mm:ss"),
            dayjs(res.endDate).format("YYYY-MM-DD HH:mm:ss"),
          ],
          amount: res.amount + "",
          useLimitType: res.useLimitType + "",
          useLimitAmount: res.useLimitAmount + "",
          useWay: res.useWay + "",
          maxSendQty: res.maxSendQty + "",
          id: res.id,
        };
        this.visible = true;
      });
    },
    handleValidate(state) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit(state);
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.visible = false;
    },
    resetInfo() {
      this.form = {
        name: "",
        validTime: "",
        amount: "",
        useLimitType: "0",
        useLimitAmount: "",
        useWay: "0",
        maxSendQty: "",
        id: "",
      };
      this.isView = false;
    },
    handleSave() {
      this.handleValidate("0");
    },
    handlePublish() {
      this.handleValidate("1");
    },
    handleUseLimitAmountFocus() {
      this.form.useLimitType = "1";
    },
  },
};
</script>
<style scoped lang="scss"></style>
